enum FORM_NAMES {
  junior = 'junior',
  middle = 'middle',
  senior = 'senior',
  others = 'others',
  numberOfGuests = 'number_of_guests',
  group_type = 'group_type',
  guests = 'guests',
}

export {FORM_NAMES};
